import * as types from '../actions/action-types';

export default (state = {
  unassignedKeys: [],
  fetchingKeys: false,
  fetchedKeys: false,
  errorFetchingKeys: null,

  keyCount: 0,
  fetchingKeyCount: false,
  fetchedKeyCount: false,
  errorFetchingKeyCount: null,

  addingKeys: false,
  addedKeys: false,
  errorAddingKeys: null,

  pendingInvites: [],
  fetchingPendingInvites: false,
  fetchedPendingInvites: false,
  errorFetchingPendingInvites: null
}, action) => {
  switch(action.type) {
    case types.ADMIN_REQUEST_STEAM_KEY_COUNT_PENDING:
      return {
        ...state,
        fetchingKeyCount: true
      };

    case types.ADMIN_REQUEST_STEAM_KEY_COUNT_FULFILLED:
      return {
        ...state,
        keyCount: action.payload.count,
        fetchingKeyCount: false,
        fetchedKeyCount: true,
        errorFetchingKeyCount: false
      };

    case types.ADMIN_REQUEST_STEAM_KEY_COUNT_REJECTED:
      return {
        ...state,
        fetchingKeyCount: false,
        fetchedKeyCount: false,
        errorFetchingKeyCount: action.payload
      };

    case types.ADMIN_REQUEST_ADD_STEAM_KEYS_PENDING:
      return {
        ...state,
        addingKeys: true,
        errorAddingKeys: null
      };

    case types.ADMIN_REQUEST_ADD_STEAM_KEYS_FULFILLED:
      return {
        ...state,
        keyCount: state.keyCount + action.payload.tokens.length,
        addingKeys: false,
        addedKeys: true,
        errorAddingKeys: null
      };

    case types.ADMIN_REQUEST_ADD_STEAM_KEYS_REJECTED:
      return {
        ...state,
        addingKeys: false,
        addedKeys: false,
        errorAddingKeys: action.payload
      };

    case types.ADMIN_REQUEST_PENDING_INVITES_PENDING:
      return {
        ...state,
        fetchingPendingInvites: true,
        fetchedPendingInvites: false,
        errorFetchingPendingInvites: null
      };

    case types.ADMIN_REQUEST_PENDING_INVITES_FULFILLED:
      return {
        ...state,
        fetchingPendingInvites: false,
        fetchedPendingInvites: true,
        errorFetchingPendingInvites: null,
        pendingInvites: action.payload.invites
      };

    case types.ADMIN_REQUEST_PENDING_INVITES_REJECTED:
      return {
        ...state,
        fetchingPendingInvites: false,
        fetchedPendingInvites: false,
        errorFetchingPendingInvites: action.payload
      };

    case types.ADMIN_REQUEST_APPROVE_INVITE_FULFILLED:
      // Filter out the invite that was just approved.
      return {
        ...state,
        pendingInvites: state.pendingInvites.filter((invite) => invite.id !== action.payload.id)
      };

    case types.ADMIN_REQUEST_CANCEL_INVITE_FULFILLED:
      // Filter out the invite that was just cancelled.
      return {
        ...state,
        pendingInvites: state.pendingInvites.filter((invite) => invite.id !== action.payload.id)
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/admin-reducer.js